module.exports = __webpack_public_path__ + "img/img_案例07.6fee0c69.png";